export const getCreteData = () => ({
  name: "Crète",
  country: "Grèce",
  description: "La Crète est la plus grande île viticole de Grèce, avec une tradition viticole millénaire et une diversité de terroirs exceptionnelle, du littoral aux montagnes.",
  type: "region",
  subregions: [
    { name: "Héraklion", area: "12,000 ha", percentage: "34%", description: "Capitale viticole de l'île" },
    { name: "Lasithi", area: "8,000 ha", percentage: "23%", description: "Vins de l'est" },
    { name: "Réthymnon", area: "7,000 ha", percentage: "20%", description: "Vins de l'ouest" },
    { name: "La Canée", area: "8,000 ha", percentage: "23%", description: "Vins du nord-ouest" }
  ],
  mapAreas: [
    { region: "Héraklion", x: 58, y: 68, color: "#4B164C", size: 6 },
    { region: "Lasithi", x: 62, y: 70, color: "#6d2c7a", size: 5 },
    { region: "Réthymnon", x: 56, y: 72, color: "#8a4a8a", size: 4 },
    { region: "La Canée", x: 54, y: 70, color: "#a768a6", size: 5 }
  ],
  statistics: {
    totalArea: "35,000 ha",
    production: "500,000 hectolitres",
    wineries: "100+ domaines",
    appellations: "4 sous-régions",
    exportPercentage: "20%"
  },
  characteristics: {
    climate: "Climat méditerranéen chaud avec influences maritimes",
    soil: "Sols calcaires, argilo-calcaires et volcaniques",
    viticulture: "Vignes en altitude (200-800m), vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges structurés et aromatiques, avec des notes d'épices et d'herbes",
    white: "Vins blancs secs et aromatiques, avec une fraîcheur exceptionnelle",
    rosé: "Rosés fruités et équilibrés, parfaits pour l'apéritif"
  },
  history: "La viticulture crétoise remonte à l'époque minoenne (3000-1100 av. J.-C.). Les Crétois ont été parmi les premiers à développer des techniques viticoles sophistiquées. Aujourd'hui, la Crète combine cette tradition ancienne avec des méthodes modernes.",
  foodPairing: "Cuisine crétoise traditionnelle, fromages locaux, fruits de mer, agneau"
}); 